import { render } from "./qonunlar-davomi.vue?vue&type=template&id=41269b2e"
import script from "./qonunlar-davomi.vue?vue&type=script&lang=js"
export * from "./qonunlar-davomi.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__